import { X } from "lucide-react";
import useDismiss from "./useDismiss";
import styles from "./Modal.module.css";

export default function Modal({ open, title, subtitle, onClose, children }) {
  useDismiss(open, onClose);

  if (!open) {
    return null;
  }

  return (
    <div
      className={`${styles.overlay} d-flex align-items-center justify-content-center`}
      onPointerDown={(event) => event.target === event.currentTarget && onClose()}
    >
      <div className={styles.dialog} role="dialog" aria-modal="true" aria-label={title}>
        <button type="button" className={styles.close} onClick={onClose} aria-label="Close">
          <X size={22} strokeWidth={1.75} />
        </button>
        <h2 className={styles.title}>{title}</h2>
        {subtitle ? <p className={styles.subtitle}>{subtitle}</p> : null}
        <div className={styles.body}>{children}</div>
      </div>
    </div>
  );
}
